import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
  selector: "ae-input-field",
  templateUrl: "./emc-input-field.component.html",
  styleUrls: ["./emc-input-field.component.scss"]
})
export class EmcInputFieldComponent {
  @Input() control: FormControl = new FormControl();
  @Input() placeholder: string;
}
